import React, { FC, useContext } from "react";
import { LocalizationContext } from "v3/context/localization";
import { TenantContext } from "v3/context/tenant";
import { Footer } from "@pepdirect/v3/ui/Footer";
import {
  getFooterBranding,
  getSortedFooterLinks,
} from "@pepdirect/v3/helpers/footer";
import { endpoints } from "v3/config";

export const CheckoutFooter: FC = () => {
  const { tenant } = useContext(TenantContext);
  const { localization } = useContext(LocalizationContext);

  // hide in Gx app
  if (
    typeof window !== "undefined" &&
    window.navigator.userAgent.includes("GxApp")
  ) {
    return <></>;
  }

  const branding = getFooterBranding(
    tenant?.brandConfig?.customizations?.contacts || [],
    tenant?.brandConfig?.customizations?.images || []
  );

  const links = getSortedFooterLinks(
    tenant?.brandConfig?.customizations?.links || [],
    endpoints.web
  );

  const FooterData = {
    branding,
    copyright: {
      brandName: tenant?.brandConfig?.copyright || "",
      localization: localization?.components?.footer,
    },
    navigation: [{ links }],
  };

  return <Footer {...FooterData} />;
};
